import { EntityLimitsTable } from './EntityLimitsTable';
import React from 'react';
export const EntityLimitsTab = ({ sonarObjectId }) => React.createElement(EntityLimitsTable, { sonarObjectId: sonarObjectId });
